import { QRCodeSVG } from 'qrcode.react';

/**
 * Renders an `otpauth://` URL as a scannable QR code for authenticator apps
 * (Google Authenticator, Authy, 1Password…). Shown during 2FA enrollment instead
 * of the raw otpauth string. The secret is still surfaced separately for manual entry.
 */
export function TotpQr({ otpauthUrl, size = 184 }: { otpauthUrl: string; size?: number }) {
  return (
    <div className="row" style={{ justifyContent: 'center', margin: '6px 0' }}>
      <div
        style={{
          background: '#fff',
          padding: 12,
          borderRadius: 10,
          border: '1px solid var(--line)',
          lineHeight: 0,
        }}
      >
        <QRCodeSVG value={otpauthUrl} size={size} level="M" />
      </div>
    </div>
  );
}
